// extracted by mini-css-extract-plugin
module.exports = {"language":"Languages-module--language--3upp3","divider":"Languages-module--divider--1xOsi"};